<template lang="html">
  <div class="extension-list">
    <div
      v-if="error"
      class="alert alert-danger text-center"
      role="alert">
      {{ error.message }}
    </div>
    <div class="card">
      <div class="card-header">
        <h3>Listagem de Ramais</h3>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-12 col-md-6 d-flex">
            <div class="input-group">
              <div class="input-group-prepend">
                <button
                  disabled
                  class="input-group-text">por página</button>
              </div>
              <select
                class="custom-select custom-select-sm form-control form-control-sm perPage"
                id="perPage"
                v-model="perPage">
                <option
                  v-for="option in pageOptions"
                  :key="option"
                  :value="option">
                  {{ option }}
                </option>
              </select>
            </div>
            <div class="ml-auto">
              <extension-new />
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="input-group filter ml-auto">
              <input
                type="text"
                class="form-control form-control-sm"
                placeholder="Buscar por"
                aria-label="Buscar por"
                v-model="filter">
              <div class="input-group-append">
                <button
                  :disabled="!filter"
                  @click="filter = ''"
                  class="input-group-text">Limpar</button>
              </div>
            </div>
          </div>
        </div>
        <div class="card-table text-left">
          <b-table
            class="table"
            show-empty
            striped
            hover
            small
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            @filtered="onFiltered">
            <template
              slot="gravarAudio"
              slot-scope="row">
              <span>{{ row.item.gravar_audio ? 'Sim' : 'Não' }}</span>
            </template>
            <template
              slot="details"
              slot-scope="row">
              <span>
                <router-link
                  class="btn btn-sm btn-primary"
                  :to="{ name: 'extensionEdit', params: { id: row.item.id }}">
                  Editar
                </router-link>
              </span>
            </template>
          </b-table>
        </div>
        <b-pagination
          align="center"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          :limit="10" />
      </div>
    </div>
  </div>
</template>

<script>
import loopback from '@/services/loopback'
import ExtensionNew from '@/components/Extension/New.vue'
import { EventBus } from '@/services/event-bus'

export default {
  name: 'ExtensionList',
  components: {
    ExtensionNew
  },
  props: {
    newExtension: {
      default: _ => {},
      type: Object
    }
  },
  data () {
    return {
      error: null,
      perPage: 10,
      pageOptions: [10, 25, 50],
      currentPage: 1,
      totalRows: 1,
      filter: null,
      fields: {
        ramal: {
          label: 'Ramal',
          sortable: true
        },
        first_name: {
          label: 'Nome',
          sortable: true
        },
        last_name: {
          label: 'Sobrenome',
          sortable: true
        },
        gravarAudio: {
          label: 'Gravar?',
          sortable: true
        },
        details: {
          label: 'ações',
          sortable: false,
          thClass: 'text-right',
          tdClass: 'text-right'
        }
      },
      items: null
    }
  },
  mounted () {
    this.getExtensions()
    EventBus.$on('new-extension-added', newExtension => {
      if (newExtension) {
        newExtension.gravar_audio = newExtension.gravar_audio ? 'Sim' : 'Não'
        newExtension.acesso_gravacoes = newExtension.acesso_gravacoes ? 'Sim' : 'Não'
        this.items.push(newExtension)
        this.totalRows = this.items.length
      }
    })
  },
  methods: {
    getExtensions () {
      loopback
        .get(`/extensions?filter[order]=ramal asc`)
        .then(extensions => {
          this.error = null
          if (extensions) {
            this.items = extensions
            this.totalRows = this.items.length
          }
        })
        .catch(err => {
          this.error = err
        })
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    isAdmin () {
      return this.$store.state.auth.user && this.$store.state.auth.user.role === 'ADMIN'
    }
  }
}
</script>

<style lang="scss" scoped>
a:not([href]):not([tabindex]) {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Extension/List.vue